import { ClubPolicies } from './ClubPolicies';

export default ClubPolicies;
